import React, { useState } from 'react';
import { List, Row, Col, Modal, Table } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import moment from 'moment';

import './index.scss';
interface props {
  logList: any;
}
const Log = (props: props) => {
  const { logList } = props;
  const [operateModalVisible, setOperateModalVisible] = useState(false);
  const columns: any = [
    {
      title: '操作人',
      dataIndex: 'operateUserName',
      key: 'operateUserName',
      align: 'center',
      width: 80,
      // eslint-disable-next-line react/display-name
      render: (text: any) => <a>{text}</a>,
    },
    {
      title: '操作时间',
      dataIndex: 'operateTime',
      key: 'operateTime',
      align: 'center',
      width: 150,
      render: (text: string) => {
        return moment.utc(text).format('YYYY-MM-DD HH:mm:ss');
      },
    },
    {
      title: '操作内容',
      align: 'center',
      dataIndex: 'operateInfo',
      key: 'operateInfo',
      width: 230,
    },
  ];
  return (
    <div className='flex1 log-con'>
      <List
        className='log-list'
        itemLayout='vertical'
        dataSource={logList}
        renderItem={(item: operateItem) => (
          <List.Item>
            <div className='m_b_5'>
              {moment(item.operateTime).format('HH:mm:ss')}
            </div>
            <div className='log-detail'>
              <Row>
                <Col span={5}>
                  <span className='gray-color-font'>操作人：</span>
                </Col>
                <Col span={19}>
                  <span>{item.operateUserName}</span>
                </Col>
              </Row>
              <Row>
                <Col span={5}>
                  <span className='gray-color-font'>操作内容：</span>
                </Col>
                <Col span={19}>
                  <span>{item.operateInfo}</span>
                </Col>
              </Row>
            </div>
          </List.Item>
        )}
      ></List>
      {logList.length > 0 && (
        <div
          className='flex cbox vbox bottom-btn'
          onClick={() => {
            setOperateModalVisible(true);
          }}
        >
          <span>
            查看全部
            <RightOutlined />
          </span>
        </div>
      )}
      <Modal
        title='操作日志'
        className='my-modal'
        footer={null}
        width='990px'
        maskClosable={false}
        visible={operateModalVisible}
        onCancel={() => {
          setOperateModalVisible(false);
        }}
      >
        <div className='log-modal-con'>
          <Table
            className='my-table '
            scroll={{
              y: '600px',
            }}
            columns={columns}
            dataSource={logList}
          ></Table>
          {logList.length > 0 && (
            <span className='data-sum'>共{logList.length}条</span>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default React.memo(Log);
